import { ContractRuleStatus } from '../../__generated__/api'

export const isPaidByOHC = (status: ContractRuleStatus | undefined) => {
  return status === undefined
    ? false
    : status !== ContractRuleStatus.Disallowed && status !== ContractRuleStatus.AssessmentRequired
}
